import { type IOrderItemV2DTO, PennyweightUtils } from '@orthly/items';

// TODO: Move these functions to a shared pennyweight util.

/** Filter pennyweights. */
export function filterPennyweights(items: IOrderItemV2DTO[]): IOrderItemV2DTO[] {
    return items.filter(PennyweightUtils.isRelevantItem);
}
